import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-[calc(100vh-64px)] flex flex-col items-center justify-center px-4 text-center">
      <p className="font-mono text-xs uppercase tracking-widest text-violet-400 mb-4">{t('notfound_errorCode')}</p>
      <h1 className="text-8xl sm:text-9xl font-black text-white tracking-tighter mb-4">{t('notfound_title')}</h1>
      <p className="text-zinc-400 text-lg mb-2">{t('notfound_subtitle')}</p>
      <p className="text-zinc-600 text-sm mb-8 max-w-xs">
        {t('notfound_description')}
      </p>
      <Link
        to="/"
        className="px-5 py-2.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold transition-colors"
      >
        {t('notfound_backToHome')}
      </Link>
    </div>
  );
};

export default NotFound;
